import React, { useState, useRef } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Terms from 'components/modules/Terms';
import Privacy from 'components/modules/Privacy';

// Icons
import Close from 'svg/close';
import Play from 'svg/play-alt';
import Arrow from 'svg/arrow';

// Video
import basicsVid from 'static/video/basics_hb.mp4';
import multipleVid from 'static/video/multiple_hb.mp4';

// Images
import tab_00 from 'static/images/tab-8bit-chocolatey.png';
import tab_01 from 'static/images/tab-8bit-creamy.png';
import tab_02 from 'static/images/tab-8bit-crunchy.png';
import tab_10 from 'static/images/tab-house-chocolatey.png';
import tab_11 from 'static/images/tab-house-creamy.png';
import tab_12 from 'static/images/tab-house-crunchy.png';
import tab_20 from 'static/images/tab-puffs-chocolatey.png';
import tab_21 from 'static/images/tab-puffs-creamy.png';
import tab_22 from 'static/images/tab-puffs-crunchy.png';
import tab_30 from 'static/images/tab-slurp-chocolatey.png';
import tab_31 from 'static/images/tab-slurp-creamy.png';
import tab_32 from 'static/images/tab-slurp-crunchy.png';
import tab_40 from 'static/images/tab-wavy-chocolatey.png';
import tab_41 from 'static/images/tab-wavy-creamy.png';
import tab_42 from 'static/images/tab-wavy-crunchy.png';
import tutorialBasics from 'static/images/tutorial_basics.jpg';
import tutorialMultiple from 'static/images/tutorial_multiple.jpg';

// install Swiper components
SwiperCore.use([Navigation]);

/**
 * Hints
 *
 * Show hints to the user
 */
const Hints = (props) => {
  const close = props.closeAction;
  const [showTutorials, setShowTutorials] = useState(false);
  const [showStarters, setShowStarters] = useState(false);
  const [showStarterGallery, setShowStarterGallery] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showBasicsVid, setShowBasicsVid] = useState(false);
  const [showMultipleVid, setShowMultipleVid] = useState(false);
  const basicsVidRef = useRef(null);
  const multipleVidRef = useRef(null);

  // images, to loop through
  const imageArr = [tab_00, tab_01, tab_02,
                    tab_10, tab_11, tab_12,
                    tab_20, tab_21, tab_22,
                    tab_30, tab_31, tab_32,
                    tab_40, tab_41, tab_42];

  /**
   * Toggle Privacy
   */
  const togglePrivacy = () => {
    if (!showPrivacy) {
      setShowPrivacy(true);
    } else {
      setShowPrivacy(false);
    }
  }

  /**
   * Toggle terms
   */
  const toggleTerms = () => {
    if (!showTerms) {
      setShowTerms(true);
    } else {
      setShowTerms(false);
    }
  }

  const playBasicsVid = () => {
    setShowBasicsVid(true);
    setTimeout(() => {
      basicsVidRef.current.play();
    }, 500);
  }

  const playMultipleVid = () => {
    setShowMultipleVid(true);
    setTimeout(() => {
      multipleVidRef.current.play();
    }, 500);
  }

  const closeTutorialVid = () => {
    if (basicsVidRef.current) {
      basicsVidRef.current.pause();
    }
    if (multipleVidRef.current) {
      multipleVidRef.current.pause();
    }
    setTimeout(() => {
      setShowBasicsVid(false);
      setShowMultipleVid(false);
    }, 500);
  }

  return (
    <article className='Main-overlay Hints'>
      {/*Actions to control the hints*/}
      <button
        title='Close'
        className='button button--outline button__close'
        onClick={close}
      >
        <Close className='Hints__icon Hints__icon-close' title='Close' />
      </button>
      {(!showTutorials && !showStarters) && (
        <section className='Main-overlay__inner'>
          <button
            className='Hints__button button button--outline'
            onClick={() => {
              setShowTutorials(true);
            }}
          >Tutorials</button>
          <button
            className='Hints__button button button--outline'
            onClick={() => {
              setShowStarters(true);
            }}
          >Starter Beats</button>
          <div className='Hints__moreinfo'>
            <a href='https://contactus.generalmills.com/?page=http://www.generalmills.com' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Contact Us</a>
            <a href='https://www.generalmills.com/en/Company/privacy-policies/privacy-policy-cookie-US-English' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Privacy Policy</a>
            <a href='https://www.generalmills.com/en/Company/legal-terms' target='_blank' rel='noopener noreferrer' className='Intro__moreinfo-links'>Legal Terms</a>
          </div>
          {showPrivacy && (
            <Privacy closeAction={togglePrivacy} />
          )}
          {showTerms && (
            <Terms closeAction={toggleTerms} />
          )}
        </section>
      )}
      {showTutorials && (
        <section className='Hints__tutorials'>
          <div className='Hints__tutorial'>
            <h3 className='Hints__tutorial-title title'>The Basics</h3>
            <div className='Hints__tutorial-video-wrapper basics' style={{backgroundImage: `url(${tutorialBasics})`}}>
              <button className='Hints__tutorial-video-play' onClick={playBasicsVid}>
                <Play title='Play' />
              </button>
            </div>
          </div>
          <div className='Hints__tutorial'>
            <h3 className='Hints__tutorial-title title'>Multiple Instruments</h3>
            <div className='Hints__tutorial-video-wrapper multiple' style={{backgroundImage: `url(${tutorialMultiple})`}}>
              <button className='Hints__tutorial-video-play' onClick={playMultipleVid}>
                <Play title='Play' />
              </button>
            </div>
          </div>
          {showBasicsVid && (
            <div className='Hints__tutorials-video-popup'>
              <div className='Hints__tutorials-video-container'>
                <div className='Hints__tutorials-video-wrapper'>
                  <video className='Hints__tutorials-video' poster="" ref={basicsVidRef} onEnded={closeTutorialVid}>
                    <source src={basicsVid} type="video/mp4" />
                  </video>
                </div>
              </div>
              <button
                title='Close'
                className='button button--outline button__close'
                onClick={closeTutorialVid}
              >
                <Close className='Hints__icon Hints__icon-close' title='Close' />
              </button>
            </div>
          )}
          {showMultipleVid && (
            <div className='Hints__tutorials-video-popup'>
              <div className='Hints__tutorials-video-container'>
                <div className='Hints__tutorials-video-wrapper'>
                  <video className='Hints__tutorials-video' poster="" ref={multipleVidRef} onEnded={closeTutorialVid}>
                    <source src={multipleVid} type="video/mp4" />
                  </video>
                </div>
              </div>
              <button
                title='Close'
                className='button button--outline button__close'
                onClick={closeTutorialVid}
              >
                <Close className='Hints__icon Hints__icon-close' title='Close' />
              </button>
            </div>
          )}
        </section>
      )}
      {showStarters && (
        <section className='Hints__starters'>
          {!showStarterGallery ? (
            <div className='Hints__starters-splash'>
              <h3 className='Hints__starters-splash-title title'>Starter Beats</h3>
              <div className='Hints__starters-splash-description'>
                <p>Get started with some basic rhythms from classic genres!</p>
                <p>Place your PUFFS in the sample squares or change it up to create your own rhythms</p>
              </div>
              <button
                className='button'
                onClick={() => {
                  setShowStarterGallery(true);
                }}
              >Next</button>
            </div>
          ) : (
            <div className='Hints__starters-slides'>
              <Swiper
                spaceBetween={100}
                slidesPerView={1}
                navigation={{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev'
                }}
              >
                {imageArr.map((img, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <img className='Hints__starters-slides__image' src={img} alt='Starter Beat' />
                    </SwiperSlide>
                  )
                })}
              </Swiper>
              <button title='Arrow Right' className='swiper-button swiper-button-next'><Arrow className='swiper-button-icon' /></button>
              <button title='Arrow Left' className='swiper-button swiper-button-prev'><Arrow className='swiper-button-icon' /></button>
            </div>
          )}
        </section>
      )}
    </article>
  );
};

export default Hints;

